import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c("app-diagnostico", {
        attrs: {
          titulo: "Avaliação da Equipe (Competências Técnicas)",
          inicio: _vm.diagnostico.inicioResponsabilidadeChefia,
          fim: _vm.diagnostico.fimResponsabilidadeChefia,
          "gestor-gestores": _vm.avaliacoesGestores.length > 0,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _vm.semResponsabilidades
                  ? _c(
                      VCol,
                      [
                        _c("app-alert", {
                          attrs: {
                            type: "warning",
                            icon: "warning",
                            message:
                              "Não há responsabilidades disponíveis para realizar a avaliação.",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm.avaliacoes.length === 0
                  ? _c(
                      VCol,
                      [
                        _c("info-dispensa", {
                          attrs: {
                            dispensas: _vm.dispensasEquipe,
                            mensagem: "Não é possível realizar a avaliação.",
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      VCol,
                      { attrs: { centered: "", cols: "12", "no-gutters": "" } },
                      [
                        _c(
                          VTabs,
                          {
                            attrs: {
                              color: "secondary",
                              centered: "",
                              "icons-and-text": "",
                            },
                            model: {
                              value: _vm.categoria,
                              callback: function ($$v) {
                                _vm.categoria = $$v
                              },
                              expression: "categoria",
                            },
                          },
                          [
                            _c(VTabsSlider, {
                              attrs: { color: "secondary" },
                            }),
                            _vm._l(_vm.categorias.length, function (i) {
                              return _c(
                                VTab,
                                {
                                  key: i,
                                  staticClass: "mt-3",
                                  attrs: {
                                    href: "#" + _vm.categorias[i - 1].id,
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "grey--text text--darken-2",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.categorias[i - 1].descricao)
                                      ),
                                    ]
                                  ),
                                  _c(
                                    VBadge,
                                    {
                                      attrs: {
                                        color:
                                          _vm.categorias[i - 1].id ===
                                          _vm.categoria
                                            ? "secondary"
                                            : "grey",
                                        content:
                                          _vm.categorias[i - 1].quantidade === 0
                                            ? "0"
                                            : _vm.categorias[i - 1].quantidade,
                                      },
                                    },
                                    [
                                      _c(
                                        VIcon,
                                        {
                                          attrs: {
                                            color:
                                              _vm.categorias[i - 1].id ===
                                              _vm.categoria
                                                ? "secondary"
                                                : "grey",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.categorias[i - 1].icone
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            _c(
                              VTabsItems,
                              {
                                model: {
                                  value: _vm.categoria,
                                  callback: function ($$v) {
                                    _vm.categoria = $$v
                                  },
                                  expression: "categoria",
                                },
                              },
                              [
                                _vm.avaliacoesGestores.length > 0
                                  ? _c(
                                      VTabItem,
                                      { attrs: { value: "gestores" } },
                                      [
                                        _c("avaliacao", {
                                          attrs: {
                                            titulo:
                                              "AVALIAÇÃO DA EQUIPE (GESTORES)",
                                            diagnostico: _vm.diagnostico,
                                            tipo: "SUBORDINADO",
                                            perspectiva: "RESPONSABILIDADE",
                                            inicio:
                                              _vm.diagnostico
                                                .inicioResponsabilidadeChefia,
                                            fim: _vm.diagnostico
                                              .fimResponsabilidadeChefia,
                                            tutorial: _vm.tutorial,
                                            "is-avaliacao-gestores": "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function () {
                                                  return [
                                                    _vm
                                                      .avaliacoesGestoresSemResponsabilidades
                                                      .length > 0
                                                      ? _c(
                                                          "avaliacao-gestores-sem-responsabilidades",
                                                          {
                                                            attrs: {
                                                              avaliacoes:
                                                                _vm.avaliacoesGestoresSemResponsabilidades,
                                                            },
                                                          }
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            114323773
                                          ),
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.avaliacoesServidores.length > 0
                                  ? _c(
                                      VTabItem,
                                      { attrs: { value: "servidores" } },
                                      [
                                        _c("avaliacao", {
                                          attrs: {
                                            titulo:
                                              "AVALIAÇÃO DA EQUIPE (SERVIDORES)",
                                            diagnostico: _vm.diagnostico,
                                            tipo: "SUBORDINADO",
                                            perspectiva: "RESPONSABILIDADE",
                                            inicio:
                                              _vm.diagnostico
                                                .inicioResponsabilidadeChefia,
                                            fim: _vm.diagnostico
                                              .fimResponsabilidadeChefia,
                                            tutorial: _vm.tutorial,
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.dispensasEquipe.length > 0
                                  ? _c(
                                      VTabItem,
                                      { attrs: { value: "dispensas" } },
                                      [
                                        _c("info-dispensa", {
                                          attrs: {
                                            dispensas: _vm.dispensasEquipe,
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }